import { Reducer } from "react";

import { IAction } from "@selas/models";
import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectParticipant } from "../../utils/types/models";
import { initialProjectParticipantState, IProjectParticipantState } from "..";
import { AxiosError } from "axios";

const extraReducer: Reducer<IProjectParticipantState, IAction> = (state: IProjectParticipantState = initialProjectParticipantState, action: IAction) => {
	switch (action.type) {
		case "REQUEST_POST_" + Endpoint.ReimbursementPdf:
			state = {
				...state,
				isCreatingReimbursementPdf: true,
				createReimbursementPdfError: null
			};
			break;
		case "REQUEST_SUCCESS_POST_" + Endpoint.ReimbursementPdf:
			state = {
				...state,
				creatingReimbursementPdfRequestSuccess: true
			};
			break;
		case "REQUEST_FAILURE_POST_" + Endpoint.ReimbursementPdf:
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				creatingReimbursementPdfRequestSuccess: false,
				createReimbursementPdfError: payload.error
			};
			break;
		case "REQUEST_END_POST_" + Endpoint.ReimbursementPdf:
			state = {
				...state,
				isCreatingReimbursementPdf: false
			};
			break;
	}
	return state;
};

const generalProjectParticipantReducer: Reducer<IProjectParticipantState, IAction> = createEntityReducer<IProjectParticipant, IProjectParticipantState>(
	Endpoint.GeneralProjectParticipants,
	Endpoint.GeneralProjectParticipantsList,
	extraReducer
);

export default createEntityReducer<IProjectParticipant, IProjectParticipantState>(Endpoint.ProjectParticipants, Endpoint.ProjectParticipantsList, generalProjectParticipantReducer);
